// import {Field} from "@atlaskit/form";
// import type {ComponentProps} from "react";
import {cloneElement, isValidElement, type ReactElement} from "react";
import {AnankeErrorMessage} from "@vesta/ananke/components/anankeErrorMessage";
import {AnankeHelperMessage} from "@vesta/ananke/components/anankeHelperMessage";
import {AnankeLabel} from "@vesta/ananke/components/anankeLabel";

// export function Field<T>(props: ComponentProps<typeof Field<T>>) {
//     return <Field {...props} />;
// }

export function AnankeField({
    id,
    label,
    isRequired = false,
    error,
    description,
    children,
}: {
    id: string;
    label: string;
    isRequired?: boolean;
    error?: string | null;
    description?: string;
    children: ReactElement;
}) {
    if (isValidElement(children) === false) {
        throw new Error("children must be a valid React element");
    }

    const showError = error !== null && error !== undefined && error !== "";
    const showDescription = showError === true ? false : description !== undefined && description !== "";

    // Clone the child element and inject the id prop
    const childWithProps = cloneElement(
        children,
        {
            id: id,
            name: id,
            // TODO: Do this more precisely based on type of element?
            isInvalid: showError === true,
            //
        } as Record<string, unknown>,
        //
    );

    return (
        <div className="w-full grid grid-cols-1">
            <AnankeLabel
                htmlFor={id}
                isRequired={isRequired}
            >
                {label}
            </AnankeLabel>

            {childWithProps}

            {showError === true ? (
                <AnankeErrorMessage
                // testId={`${id}-error`}
                >
                    {error}
                </AnankeErrorMessage>
            ) : showDescription ? (
                <AnankeHelperMessage
                // testId={`${id}-helper`}
                >
                    {description}
                </AnankeHelperMessage>
            ) : null}
        </div>
    );
}
